import { API_URL } from '../../../config'
import store from '../../store'

const BASE = `${API_URL}/postventa/tickets`

const get = (path) =>
  fetch(`${BASE}${path}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', Authorization: store.state.token }
  }).then((r) => r.json())

const post = (path, payload) =>
  fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: store.state.token },
    body: JSON.stringify(payload)
  }).then((r) => r.json())

export default {
  namespaced: true,

  state: {
    tickets: [],
    estados: [],
    subEstados: [],
    tipos: [],
    prioridades: [],
    solicitantes: [],
    empresas: [],
    sucursales: [],
    usuariosAsignables: [],
    usuariosMenciones: [],
    comentarios: [],
    archivos: [],
    alertasDanos: [],
    alertasGarantias: [],
    cargando: false,
  },

  mutations: {
    SET_TICKETS(state, data)            { state.tickets = data },
    SET_ESTADOS(state, data)            { state.estados = data },
    SET_SUB_ESTADOS(state, data)        { state.subEstados = data },
    SET_TIPOS(state, data)              { state.tipos = data },
    SET_PRIORIDADES(state, data)        { state.prioridades = data },
    SET_SOLICITANTES(state, data)       { state.solicitantes = data },
    SET_EMPRESAS(state, data)           { state.empresas = data },
    SET_SUCURSALES(state, data)         { state.sucursales = data },
    SET_USUARIOS_ASIGNABLES(state, data){ state.usuariosAsignables = data },
    SET_USUARIOS_MENCIONES(state, data) { state.usuariosMenciones = Array.isArray(data) ? data : [] },
    SET_COMENTARIOS(state, data)        { state.comentarios = data },
    SET_ARCHIVOS(state, data)           { state.archivos = data },
    SET_ALERTAS_DANOS(state, data)      { state.alertasDanos = data },
    SET_ALERTAS_GARANTIAS(state, data)  { state.alertasGarantias = data },
    SET_CARGANDO(state, val)            { state.cargando = val },
  },

  actions: {
    // --- Catálogos ---
    async getEstados({ commit }) {
      const res = await get('/estados')
      if (res.exito) commit('SET_ESTADOS', res.data)
      return res
    },

    async getSubEstados({ commit }) {
      const res = await get('/sub-estados')
      if (res.exito) commit('SET_SUB_ESTADOS', res.data)
      return res
    },
    async getSubEstadosAdmin({ commit }) {
      const res = await get('/sub-estados-admin')
      if (res.exito) commit('SET_SUB_ESTADOS', res.data)
      return res
    },

    async getTipos({ commit }) {
      const res = await get('/tipos')
      if (res.exito) commit('SET_TIPOS', res.data)
      return res
    },

    async getPrioridades({ commit }) {
      const res = await get('/prioridades')
      if (res.exito) commit('SET_PRIORIDADES', res.data)
      return res
    },

    async getSolicitantes({ commit }) {
      const res = await get('/solicitantes')
      if (res.exito) commit('SET_SOLICITANTES', res.data)
      return res
    },

    async getEmpresas({ commit }) {
      const res = await get('/empresas')
      if (res.exito) commit('SET_EMPRESAS', res.data)
      return res
    },

    async getSucursales({ commit }) {
      const res = await get('/sucursales')
      if (res.exito) commit('SET_SUCURSALES', res.data)
      return res
    },

    async getUsuariosAsignables({ commit }) {
      const res = await get('/usuarios-asignables')
      if (res.exito) commit('SET_USUARIOS_ASIGNABLES', res.data)
      return res
    },
    async getUsuariosAsignablesGarantias() {
      return get('/usuarios-asignables-garantias')
    },

    /**
     * @param {{ roles: number[] | string }} payload roles: 'todos' o [1,50,54,56]
     */
    async getUsuariosMenciones({ commit }, payload = {}) {
      const { roles } = payload
      let q = 'todos'
      if (Array.isArray(roles)) {
        const ids = roles
          .map((n) => parseInt(String(n), 10))
          .filter((n) => Number.isInteger(n) && n > 0)
        q = ids.length ? ids.join(',') : 'todos'
      } else if (typeof roles === 'string' && roles.trim().toLowerCase() === 'todos') {
        q = 'todos'
      } else if (typeof roles === 'string' && roles.trim()) {
        q = roles.trim()
      }
      const res = await get(`/usuarios-menciones?roles=${encodeURIComponent(q)}`)
      if (res.exito) commit('SET_USUARIOS_MENCIONES', res.data)
      return res
    },

    // --- Alertas daños ---
    async getAlertasDanos({ commit }) {
      const res = await get('/alertas-danos')
      if (res.exito) commit('SET_ALERTAS_DANOS', res.data)
      return res
    },
    async getAlertasGarantias({ commit }) {
      const res = await get('/alertas-garantias')
      if (res.exito) commit('SET_ALERTAS_GARANTIAS', res.data)
      return res
    },

    async procesarAlertasUnidadesDaniadas() {
      // Endpoint "idempotente": si no hay alertas pendientes, no hace nada.
      return post('/procesar-alertas-unidades-daniadas', {})
    },
    async procesarAlertasOrdenesGarantias() {
      // Endpoint "idempotente": si no hay alertas pendientes, no hace nada.
      return post('/procesar-alertas-ordenes-garantias', {})
    },

    // --- Tickets ---
    async getTickets({ commit }, filtro = {}) {
      commit('SET_CARGANDO', true)
      const res = await post('/', filtro)
      if (res.exito) commit('SET_TICKETS', res.data)
      commit('SET_CARGANDO', false)
      return res
    },

    async getMisTickets({ commit }, filtro = {}) {
      commit('SET_CARGANDO', true)
      const res = await post('/mis-tickets', filtro)
      if (res.exito) commit('SET_TICKETS', res.data)
      commit('SET_CARGANDO', false)
      return res
    },

    async nuevoTicket({}, payload) {
      return post('/nuevo', payload)
    },

    async recepcion0km({}, payload) {
      return post('/recepcion-0km', payload)
    },

    async getMiContextoRecepcion() {
      return get('/mi-contexto-recepcion')
    },
    async getRecepcion0kmListado() {
      return get('/recepcion-0km/listado')
    },
    async getPreEntregasListado() {
      return get('/pre-entregas/listado')
    },
    async getPreEntregasTickets() {
      return get('/pre-entregas/tickets')
    },
    async getPreEntregasUbicaciones() {
      return get('/pre-entregas/ubicaciones')
    },
    async getPreEntregasMecanicos() {
      return get('/pre-entregas/mecanicos')
    },
    async ejecutarPreEntrega({}, payload) {
      return post('/pre-entregas/ejecutar', payload)
    },
    async rechazarPreEntrega({}, payload) {
      return post('/pre-entregas/rechazar', payload)
    },
    async actualizarRecepcion0km({}, payload) {
      return post('/recepcion-0km/actualizar', payload)
    },
    async getGaleriaUnidadGarantias({}, payload) {
      return post('/galeria-unidad-garantias', payload)
    },
    async garantiasEvidencias({}, payload) {
      return post('/garantias-evidencias', payload)
    },
    async getGarantiasOrdenServicioContexto({}, payload) {
      return post('/garantias-evidencias/orden-servicio-contexto', payload)
    },
    async getContextoNuevoTicketOrden({}, payload) {
      return post('/contexto-nuevo-ticket-orden', payload)
    },
    async getGarantiasEvidenciasListado() {
      return get('/garantias-evidencias/listado')
    },
    async actualizarGarantiasEvidencias({}, payload) {
      return post('/garantias-evidencias/actualizar', payload)
    },
    async asegurarGarantiasEvidenciasPorTicket({}, payload) {
      return post('/garantias-evidencias/asegurar-por-ticket', payload)
    },
    async actualizarPrecioRepuestoGarantia({}, payload) {
      return post('/garantias-repuestos/precio', payload)
    },
    async getGaleriaGarantiasPorOrden({}, payload) {
      return post('/galeria-garantias-por-orden', payload)
    },

    async guardarGarantiasProforma({}, payload) {
      return post('/garantias-proforma/guardar', payload)
    },

    async getGarantiasProformaUltima({}, payload) {
      const ticketId = Number(payload?.ticket_id)
      if (!Number.isInteger(ticketId) || ticketId <= 0) {
        return { exito: false, message: 'ticket_id inválido', data: null }
      }
      return get(`/garantias-proforma/ultima?ticket_id=${encodeURIComponent(String(ticketId))}`)
    },

    async asignarTicket({}, payload) {
      return post('/asignar', payload)
    },
    async guardarDetalleTicket({}, payload) {
      return post('/guardar-detalle', payload)
    },

    async finalizarTicket({}, payload) {
      return post('/finalizar', payload)
    },

    async reabrirTicket({}, payload) {
      return post('/reabrir', payload)
    },

    async cambiarSubEstado({}, payload) {
      return post('/sub-estado', payload)
    },
    async cambiarPrioridad({}, payload) {
      return post('/prioridad', payload)
    },
    async cambiarReparacionPrimeraVisita({}, payload) {
      return post('/reparacion-primera-visita', payload)
    },
    async altaSubEstado({}, payload) {
      return post('/sub-estados/alta', payload)
    },
    async editarSubEstado({}, payload) {
      return post('/sub-estados/editar', payload)
    },
    async bajaSubEstado({}, payload) {
      return post('/sub-estados/baja', payload)
    },
    async reactivarSubEstado({}, payload) {
      return post('/sub-estados/reactivar', payload)
    },
    async eliminarSubEstadoDefinitivo({}, payload) {
      return post('/sub-estados/eliminar', payload)
    },
    async getDestinatariosReparacion({}, payload = {}) {
      const empresaId = Number(payload.empresa_id)
      const params = []
      if (Number.isInteger(empresaId) && empresaId > 0) {
        params.push(`empresa_id=${encodeURIComponent(String(empresaId))}`)
      }
      if (payload.tipo_alerta) {
        params.push(`tipo_alerta=${encodeURIComponent(String(payload.tipo_alerta))}`)
      }
      const q = params.length > 0 ? `?${params.join('&')}` : ''
      return get(`/destinatarios-reparacion${q}`)
    },
    async altaDestinatarioReparacion({}, payload) {
      return post('/destinatarios-reparacion/alta', payload)
    },
    async editarDestinatarioReparacion({}, payload) {
      return post('/destinatarios-reparacion/editar', payload)
    },
    async bajaDestinatarioReparacion({}, payload) {
      return post('/destinatarios-reparacion/baja', payload)
    },
    async reactivarDestinatarioReparacion({}, payload) {
      return post('/destinatarios-reparacion/reactivar', payload)
    },

    // --- Destinatarios Pre Entrega ---
    async getPreEntregasPermisos() {
      return get('/pre-entregas/permisos')
    },
    async getDestinatariosPreEntrega({}, payload = {}) {
      const empresaId = Number(payload.empresa_id)
      const params = []
      if (Number.isInteger(empresaId) && empresaId > 0) {
        params.push(`empresa_id=${encodeURIComponent(String(empresaId))}`)
      }
      if (payload.tipo_alerta) {
        params.push(`tipo_alerta=${encodeURIComponent(String(payload.tipo_alerta))}`)
      }
      const q = params.length > 0 ? `?${params.join('&')}` : ''
      return get(`/destinatarios-reparacion${q}`)
    },
    async altaDestinatarioPreEntrega({}, payload) {
      return post('/destinatarios-reparacion/alta', payload)
    },
    async editarDestinatarioPreEntrega({}, payload) {
      return post('/destinatarios-reparacion/editar', payload)
    },
    async bajaDestinatarioPreEntrega({}, payload) {
      return post('/destinatarios-reparacion/baja', payload)
    },
    async reactivarDestinatarioPreEntrega({}, payload) {
      return post('/destinatarios-reparacion/reactivar', payload)
    },

    // --- Comentarios ---
    async getComentarios({ commit }, payload) {
      const res = await post('/comentarios', payload)
      if (res.exito) commit('SET_COMENTARIOS', res.data)
      return res
    },

    async nuevoComentario({}, payload) {
      return post('/nuevo-comentario', payload)
    },

    // --- Archivos ---
    async getArchivos({ commit }, payload) {
      const res = await post('/archivos', payload)
      if (res.exito) commit('SET_ARCHIVOS', res.data)
      return res
    },

    async cargarArchivos({}, payload) {
      return post('/cargar-archivos', payload)
    },
  },
}
